import type { BenchmarkHintVariant, BenchmarkRun } from "./types";

const HINT_VARIANTS: Array<{ variant: BenchmarkHintVariant; label: string }> = [
  { variant: "baseline", label: "Baseline" },
  { variant: "keywords", label: "Keywords" },
  { variant: "prompt", label: "Prompt" },
  { variant: "combined", label: "Combined" },
];

type HintVariantCoverageSummary = {
  hint_variants?: {
    providers?: Record<string, {
      variants?: Partial<Record<BenchmarkHintVariant, { cell_count?: number }>>;
    }>;
  } | null;
};

export function benchmarkHintVariantCellCounts(summary: HintVariantCoverageSummary) {
  const providers = Object.values(summary.hint_variants?.providers ?? {});
  return HINT_VARIANTS.map(({ variant, label }) => ({
    variant,
    label,
    count: providers.reduce(
      (total, provider) => total + (provider.variants?.[variant]?.cell_count ?? 0),
      0,
    ),
  })).filter(({ count }) => count > 0);
}

type HintVariantJudgeSummary = {
  judged_cells: number;
  material_errors?: number;
  material_error_rate: number | null;
};

export function benchmarkMaterialErrorCount(judge: HintVariantJudgeSummary) {
  if (judge.material_errors != null) return judge.material_errors;
  if (judge.material_error_rate == null || judge.judged_cells === 0) return null;
  return Math.round(judge.material_error_rate * judge.judged_cells);
}

export function mergeBenchmarkSummaries(
  base: BenchmarkRun["summary"] | undefined,
  override: BenchmarkRun["summary"] | undefined,
): BenchmarkRun["summary"] {
  return {
    ...(base ?? {}),
    ...Object.fromEntries(
      Object.entries(override ?? {}).filter(([, value]) => value != null),
    ),
  } as BenchmarkRun["summary"];
}
